export default __webpack_public_path__ + "static/media/hp.28b8aa3d.png";